import {type HTMLAttributes} from 'react';
import {CopyIcon} from '../copy-icon';
import {cn} from '../lib/cn';

type CopyStringProps = HTMLAttributes<HTMLDivElement> & {
  value?: string;
};

function CopyString({value = '', className, ...props}: CopyStringProps) {
  return (
    <div className={cn('flex w-fit items-center gap-2', className)} {...props}>
      <div className="copy-string_value w-full overflow-hidden text-ellipsis whitespace-nowrap text-left">
        {value}
      </div>
      <CopyIcon textToCopy={value} />
    </div>
  );
}

export {CopyString};
export type {CopyStringProps};
